import Papa from 'papaparse'

const parse = (file, options) => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, { complete: resolve, error: reject, skipEmptyLines: true, ...options })
  })
}

const unparse = (data, options) => {
  return Papa.unparse(data, options)
}

export default {
  parse,
  unparse
}
